import { StrictBehavior } from '../../behavior';
import { BehaviorContext } from '../../behavior-context';
import { OTP_CONTACT_ID, OTP_CONTACT_METHOD } from '../otp/otp-util';
import { PgInputFactoryComponent } from 'projects/grit-core/src/lib/pg-field/pg-input-factory/pg-input-factory.component';
import { Injectable } from '@angular/core';

@Injectable()
export class PrepopulateContactInfo extends StrictBehavior {
  constructor() {
    super();
  }
  async executeBehavior(
    args: { mobilePhoneId: string; emailId: string },
    ctx: BehaviorContext
  ): Promise<any> {
    const contactId = ctx.get(OTP_CONTACT_ID);
    const contactMethod = ctx.get(OTP_CONTACT_METHOD);

    if (contactMethod === 0) {
      const inputFact: PgInputFactoryComponent = ctx.getFactoryById(
        args.mobilePhoneId
      );
      inputFact.input.value = contactId;
      inputFact.model.disabled = true;
    } else if (contactMethod === 1) {
      const inputFact: PgInputFactoryComponent = ctx.getFactoryById(
        args.emailId
      );
      inputFact.input.value = contactId;
      inputFact.model.disabled = true;
    }
  }
}
